import { ApplicationError } from "@/error/ApplicationError";
import type { UnknownRecord } from "@/utils/type";

export class BackendError extends ApplicationError {
  constructor(
    name: string,
    message: string,
    contexts: { request: UnknownRecord; response: UnknownRecord },
  ) {
    super(name, message, contexts);
  }
}
